'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (Cart, $) {
    'use strict';

    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.cartQtyButton = $('[data-item-quantity-change]');
      $dom.cartQty = $('[data-item-quantity]');
      $dom.cartForm = $('[data-cart-form]');
    };

    var validateQty = function validateQty(qty) {
      if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        qty = 1;
      }
      return qty;
    };

    var bindUiActions = function bindUiActions() {
      $dom.cartQtyButton.on('click', function () {
        var $qtySelector = $(this).siblings('[data-item-quantity]');
        var qty = validateQty(parseInt($qtySelector.val().replace(/\D/g, '')));
        // Add or subtract from the current quantity
        if ($(this).is('[data-item-quantity-plus]')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 0) qty = 0;
        }
        // Update the input's number
        $qtySelector.val(qty);
        $dom.cartForm.attr('action', 'cart/update').submit();
      });
      $dom.cartQty.on('blur', function () {
        var qty = validateQty(parseInt($(this).val().replace(/\D/g, '')));
        $(this).val(qty);
        $dom.cartForm.attr('action', 'cart/update').submit();
      });
    };

    Cart.init = function () {
      cacheDom();
      bindUiActions();
    };
  })(window.Cart = window.Cart || {}, _jquery2.default);
};